var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 165C135.899 165 165 135.899 165 100C165 64.1015 135.899 35 100 35C64.1015 35 35 64.1015 35 100C35 135.899 64.1015 165 100 165Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.413 47.3334H37.6867C32.3369 47.3334 28 51.6702 28 57.02V143.38C28 148.73 32.3369 153.067 37.6867 153.067H162.413C167.763 153.067 172.1 148.73 172.1 143.38V57.02C172.1 51.6702 167.763 47.3334 162.413 47.3334Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.32 47H163.873C168.42 47 172.107 50.6867 172.107 55.2333V59.5067H28V57.3133C28 51.62 32.62 47 38.3133 47H38.32Z",
    fill: "#36A635"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 59.8402H172.1",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.413 47H37.6867C32.3369 47 28 51.3368 28 56.6866V143.047C28 148.396 32.3369 152.733 37.6867 152.733H162.413C167.763 152.733 172.1 148.396 172.1 143.047V56.6866C172.1 51.3368 167.763 47 162.413 47Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.027 68.6537H42.0801C39.5027 68.6537 37.4134 70.743 37.4134 73.3203V139.36C37.4134 141.938 39.5027 144.027 42.0801 144.027H158.027C160.604 144.027 162.693 141.938 162.693 139.36V73.3203C162.693 70.743 160.604 68.6537 158.027 68.6537Z",
    fill: "#ECEEF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9467 77H127.6C131.987 77 135.547 80.56 135.547 84.9467V118.72C135.547 123.107 131.987 126.667 127.6 126.667H97.8L85.3 141.153C84.0467 142.407 81.9067 141.52 81.9067 139.747V126.667H75.9467C71.56 126.667 68 123.107 68 118.72V84.9467C68 80.56 71.56 77 75.9467 77Z",
    fill: "#AEAEAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.433 74.0068H124.086C128.473 74.0068 132.033 77.5668 132.033 81.9535V115.727C132.033 120.113 128.473 123.674 124.086 123.674H94.2863L81.7863 138.16C80.533 139.413 78.393 138.527 78.393 136.753V123.674H72.433C68.0463 123.674 64.4863 120.113 64.4863 115.727V81.9535C64.4863 77.5668 68.0463 74.0068 72.433 74.0068Z",
    fill: "#36A635",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7 91.92C91.7 87.9734 94.3133 85.36 98.26 85.36C102.127 85.36 104.82 88.06 104.82 91.92C104.82 94.18 103.173 96.6667 101.533 97.98C98.8467 100.127 98.3533 101.893 98.3533 105.333",
    stroke: "white",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3134 56.1402C38.7236 56.1402 39.8667 54.9971 39.8667 53.5869C39.8667 52.1767 38.7236 51.0335 37.3134 51.0335C35.9032 51.0335 34.7601 52.1767 34.7601 53.5869C34.7601 54.9971 35.9032 56.1402 37.3134 56.1402Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.34 56.1402C47.7501 56.1402 48.8933 54.9971 48.8933 53.5869C48.8933 52.1767 47.7501 51.0335 46.34 51.0335C44.9298 51.0335 43.7866 52.1767 43.7866 53.5869C43.7866 54.9971 44.9298 56.1402 46.34 56.1402Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3733 56.1402C56.7835 56.1402 57.9267 54.9971 57.9267 53.5869C57.9267 52.1767 56.7835 51.0335 55.3733 51.0335C53.9632 51.0335 52.82 52.1767 52.82 53.5869C52.82 54.9971 53.9632 56.1402 55.3733 56.1402Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2599 115.674C99.8984 115.674 101.227 114.345 101.227 112.707C101.227 111.068 99.8984 109.74 98.2599 109.74C96.6215 109.74 95.2933 111.068 95.2933 112.707C95.2933 114.345 96.6215 115.674 98.2599 115.674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportV2);
export default __webpack_public_path__ + "static/media/SupportV2.6f0f90381820ce191edb025267405909.svg";
export { ForwardRef as ReactComponent };